/**
 * Billing Entities feature auto-registration and exports
 *
 * This module automatically registers the billing entities feature when imported,
 * enabling management of billing identities (NPI + Tax ID).
 */

import { autoRegisterFeature } from '@store/features/factory';

import { billingEntitiesFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(billingEntitiesFeature);

// Export store (all store-related exports)
export * from './store';

// Export types
export * from './types';
